import initJwt from '@/cubus/jwt/initJwt'
import axios from '@axios'

const { jwt } = initJwt(axios, {})
export default jwt
